export default "__VITE_ASSET__bB_Bvb74__"